export default __webpack_public_path__ + "static/media/trus3.f7344e4b.png";